import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscription, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Eventsetup } from './eventsetup';
import { environment } from '../../environments/environment';
import { SlidePlaylist } from './slide';

@Injectable({
  providedIn: 'root'
})
export class EventsetupStoreService {

  private subscriptions: Subscription[] = [];


  private api = environment.apiUrl + 'api';

  storedSetup: Eventsetup;


  constructor(private http: HttpClient) { }

  _isPendingEventSetup = new ReplaySubject<boolean>(1);
  isPendingEventSetup$ = this._isPendingEventSetup.asObservable();

  private eventSetupSource = new ReplaySubject<Eventsetup>(1);
  public readonly setup$ = this.eventSetupSource.asObservable();


  getEventSetup() {
    this._isPendingEventSetup.next(true);
    this.subscriptions.push(
      this.getSetup().subscribe({
        next: (setup: Eventsetup) => {
          // Emit different parts of the config to respective subjects
          this.eventSetupSource.next(setup);
          this._isPendingEventSetup.next(false);
        },
        error: (err) => {
          console.error('Error fetching slide config', err);
              this._isPendingEventSetup.next(false);
        }
      })
    );
  }

  getSetup(){
    return this.http.get<Eventsetup>(`${this.api}/api.php?x=get_setup`)
    .pipe(
      retry(1),
      catchError(this.errorHandler)
      );
  }

  setStoredSetup(setup: Eventsetup){
    this.storedSetup = setup;
  }

  getStoredSetup(){
    return this.storedSetup;
  }

  private errorHandler(error: HttpErrorResponse): Observable<any> {
    console.error('Fehler aufgetreten!');
    return throwError(error);
  }
}
